import { createGlobalStyle } from "styled-components/macro";
import reset from "styled-reset";

import { colors, fontStyle, fontSize, breakpoint } from "./constants";
import { defaultLink } from "./defaults";

export const GlobalStyle = createGlobalStyle`
  ${reset}

  html, body, #root, main {
    height: 100%;
  }

  body {
    overflow-x: hidden;

    max-width: 100vw;

    background-color: ${colors.extraBlack};

    ${fontStyle.regular}
    ${fontSize.s}
    color: ${colors.white};
    line-height: 1.25;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    scroll-behavior: smooth;

    @media print {
      background-color: transparent;
      span.pageNumber,
      span.totalPages {
        margin-bottom: 30px;
      }
    }
  }

  * {
    box-sizing: border-box;
  }

  button,
  input[type="reset"],
  input[type="submit"] {
    cursor: pointer;

    border: none;
    border-radius: 0;
    padding: 0;
    margin: 0;

    background-color: transparent;

    color: inherit;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    font-style: inherit;

    &:not([class]) {
      ${defaultLink()}
    }
  }

  label {
    cursor: pointer;
  }

  svg {
    color: ${colors.grey4};
  }

  svg,
  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: inherit;

    &:not([class]) {
      ${defaultLink()}
    }
  }

  p {
    margin: 0;
    line-height: 150%;

    ul {
      list-style: disc;

      li {
        margin-left: 1rem;
      }

      li + li {
        margin-top: 1rem;
      }
    }

    strong {
      font-weight: bold !important;
    }

    em {
      font-style: italic !important;
    }
  }

  input, select, textarea {
    min-width: 0;
    font-size: inherit;
    border: none;

   // prevent auto zoom on Safari
    ${breakpoint("s", "down")} {
      ${fontSize.l}
    }
  }

  textarea {
    resize: none;
  }

  fieldset {
    display: table; // reset weird legend styles
  }

  h1, h2, h3, h4 {
    margin: 0;
  }
`;
